import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Mousewheel } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

let articleSwiper = null;
let detailSwiper = null;
let isDetailView = false;
let GLOBAL_SPEED_MS = null;
let GLOBAL_REPEAT_ENABLED = false;



const articleContainer = document.getElementById('article-swiper');
const contentDiv = document.getElementById('post-content');

const earlyParams = new URLSearchParams(window.location.search);
if (earlyParams.has('p')) {
  articleContainer.style.visibility = 'hidden';
  articleContainer.classList.add('hidden');
  document.body.style.backgroundColor = 'black'; // voliteľné, aby nepreblikol obsah
}

// 🔹 Vytvor a vlož tlačidlo ✖ na zatvorenie detailu
const closeDetailBtn = document.createElement('button');
closeDetailBtn.id = 'close-detail-btn';
closeDetailBtn.textContent = '✖';
document.body.appendChild(closeDetailBtn);

// Kliknutie na ✖ zatvorí detail
closeDetailBtn.addEventListener('click', () => {
  if (isDetailView) closeDetail();
});

/* ==============================
   TAJNÉ MENU PRE ZMENU DOMÉNY A KATEGÓRIE
================================= */

const settingsPanel = document.getElementById('hidden-settings');
const domainInput   = document.getElementById('domain-input');
const categoryInput = document.getElementById('category-input');
const tokenInput    = document.getElementById('token-input');
const saveBtn       = document.getElementById('save-settings');

let WP_DOMAIN   = localStorage.getItem('wpDomain') || window.location.origin;
let CATEGORY_ID = localStorage.getItem('categoryId') || 24;
let LICENSE_TOKEN = localStorage.getItem('licenseToken') || '';

domainInput.value   = WP_DOMAIN;
categoryInput.value = CATEGORY_ID;
tokenInput.value    = LICENSE_TOKEN;


const settingsOverlay = document.getElementById('settings-overlay');
const closeBtn = document.getElementById('close-settings');

// Stlačenie „O“ otvorí / zavrie panel
document.addEventListener('keydown', (e) => {
  if (e.key.toLowerCase() === 'o') {
    e.preventDefault();
    const visible = settingsPanel.style.display === 'flex';
    settingsPanel.style.display = visible ? 'none' : 'flex';
    settingsOverlay.style.display = visible ? 'none' : 'flex';
  }
});

const openBtn = document.getElementById('open-settings-btn');

openBtn.addEventListener('click', () => {
  const visible = settingsPanel.style.display === 'flex';
  settingsPanel.style.display = visible ? 'none' : 'flex';
  settingsOverlay.style.display = visible ? 'none' : 'flex';
});

// Zavrieť tlačidlom ✖
closeBtn.addEventListener('click', () => {
  settingsPanel.style.display = 'none';
  settingsOverlay.style.display = 'none';
});

// Klik mimo panel zatvorí tiež
settingsOverlay.addEventListener('click', () => {
  settingsPanel.style.display = 'none';
  settingsOverlay.style.display = 'none';
});

// Po kliknutí Uložiť
saveBtn.addEventListener('click', () => {
  const domain = domainInput.value.trim();
  const cat = parseInt(categoryInput.value.trim(), 10);
  const token = tokenInput.value.trim();

  if (!domain.startsWith('http')) {
    alert('⚠️ Zadaj platnú doménu');
    return;
  }
  if (!Number.isFinite(cat) || cat <= 0) {
    alert('⚠️ Zadaj platné ID kategórie');
    return;
  }

  WP_DOMAIN = domain.replace(/\/+$/, '');
  CATEGORY_ID = cat;
  LICENSE_TOKEN = token;

  localStorage.setItem('wpDomain', WP_DOMAIN);
  localStorage.setItem('categoryId', String(cat));
  localStorage.setItem('licenseToken', token);

  alert('✅ Nastavené. Načítavam...');
  location.reload();
});

// ========== AUTOMATICKÉ ZOBRAZENIE PRI PRVOM VSTUPE ==========
window.addEventListener('DOMContentLoaded', () => {
  const shown = localStorage.getItem('settingsShown');
  if (!shown) {
    // zobraz panel len ak ešte nebol otvorený
    settingsPanel.style.display = 'flex';
    settingsOverlay.style.display = 'flex';
  }
});

// Keď používateľ klikne na "Uložiť" alebo "Zavrieť", zapamätaj si že už videl panel
saveBtn.addEventListener('click', () => {
  let domain = domainInput.value.trim();
  let cat = parseInt(categoryInput.value.trim(), 10);
  const token = tokenInput.value.trim();

  // 🔹 ak sú polia prázdne → použi predvolené hodnoty
  if (!domain) domain = 'https://www.divartwp.sk';
  if (!Number.isFinite(cat) || cat <= 0) cat = 24;

  // 🔹 validácia domény
  if (!domain.startsWith('http')) {
    alert('⚠️ Zadaj platnú doménu (napr. https://www.divartwp.sk)');
    return;
  }

  WP_DOMAIN = domain.replace(/\/+$/, '');
  CATEGORY_ID = cat;
  LICENSE_TOKEN = token;

  localStorage.setItem('wpDomain', WP_DOMAIN);
  localStorage.setItem('categoryId', String(cat));
  localStorage.setItem('licenseToken', token);

  alert(`✅ Nastavené: ${WP_DOMAIN} (kat. ${CATEGORY_ID})`);
  location.reload();
});

closeBtn.addEventListener('click', () => {
  localStorage.setItem('settingsShown', '1');
  settingsPanel.style.display = 'none';
  settingsOverlay.style.display = 'none';
});


// index.js
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', async () => {
//     try {
//       const swUrl = new URL('./sw.js', import.meta.url); // 👈 dôležité pre Parcel
//       await navigator.serviceWorker.register(swUrl, { scope: './' });

//       if (navigator.storage?.persist) await navigator.storage.persist();
//       if (navigator.storage?.estimate) {
//         const {usage, quota} = await navigator.storage.estimate();
//         console.log(`Cache: ${(usage/1e6).toFixed(1)}MB / ${(quota/1e6).toFixed(1)}MB`);
//       }
//     } catch (e) {
//       console.warn('SW register fail', e);
//     }
//   });
// }

function clampIndex(sw, idx){
  if (!sw) return 0;
  return Math.max(0, Math.min(sw.slides.length - 1, idx));
}

function getSpeedForIndex(sw, idx){
  if (!sw) return 800;
  const slide = sw.slides[idx];
  if (!slide) return 800;
  if (GLOBAL_SPEED_MS != null) return GLOBAL_SPEED_MS;
  const ds = slide.dataset?.speed;
  if (ds != null && ds !== '') {
    const v = parseFloat(ds);
    if (Number.isFinite(v)) return v;
  }
  return Number.isFinite(sw.params?.speed) ? sw.params.speed : 800;
}

function updateEdgeLock(sw){
  const isFirst = sw.activeIndex === 0;

  // Swiper-level blokáda „prev“
  sw.allowSlidePrev = !isFirst;
  sw.params.allowSlidePrev = !isFirst;

  // UI: zneaktívni šípku späť
  const prevBtn = contentDiv.querySelector('.swiper-button-prev');
  if (prevBtn) {
    prevBtn.classList.toggle('is-disabled', isFirst);
    prevBtn.style.pointerEvents = isFirst ? 'none' : '';
    prevBtn.setAttribute('aria-disabled', isFirst ? 'true' : 'false');
  }
}

function navImmediate(sw, delta){
  if (!sw) return;

  if (delta < 0 && sw.activeIndex === 0) return;

  if (sw.nextTimeout) { clearTimeout(sw.nextTimeout); sw.nextTimeout = null; }

  const targetRaw = sw.activeIndex + delta;

   // pod prvý slide už nikdy nechoď

  if (targetRaw < 0) return;

  if (targetRaw >= sw.slides.length) {
    if (GLOBAL_REPEAT_ENABLED) {
      const speed = getSpeedForIndex(sw, 0);
      sw.params.speed = speed;
      sw.update();
      sw.slideTo(0);
    } else {
      // Zavri detail
      closeDetail();
  
      // 🟢 Po zatvorení detailu preskoč vždy o JEDEN článok (či auto:true alebo auto:false)
      setTimeout(() => {
        if (!articleSwiper) return;
        const nextIdx = (articleSwiper.activeIndex + 1) % articleSwiper.slides.length;
        articleSwiper.slideTo(nextIdx);
      }, 600);
    }
    return;
  }
  

  const targetIdx = Math.max(0, Math.min(sw.slides.length - 1, targetRaw));
  if (targetIdx === sw.activeIndex) return;

  const spd = getSpeedForIndex(sw, targetIdx);
  sw.params.speed = spd;
  sw.update();

  const v = sw.slides[targetIdx]?.querySelector('video');
  prebufferVideo(v);

  sw.slideTo(targetIdx);
  clearTimeout(sw._vidStartTimer);
sw._vidStartTimer = setTimeout(() => startActiveVideoNow(sw), 1000);
}

let GLOBAL_AUTOPLAY_ENABLED = false; // defaultne zapnuté

function readGlobalSpeed(doc, fallback=null){
  const ps = Array.from(doc.querySelectorAll('p'));
  let speedVal = fallback;

  ps.forEach(p => {
    const s = p.innerText.trim().toLowerCase();

    // 1️⃣ zisti auto:false
    if (s.startsWith('auto:')) {
      const val = s.split(':')[1]?.trim();
      if (val === 'false' || val === '0' || val === 'no' || val === 'off') {
        GLOBAL_AUTOPLAY_ENABLED = false;
      } else if (val === 'true' || val === '1' || val === 'yes' || val === 'on') {
        GLOBAL_AUTOPLAY_ENABLED = true;
      }
      p.remove();
      return;
    }

    if (s.startsWith('repeat:')) {
      const val = s.split(':')[1]?.trim();
      if (val === 'true' || val === '1' || val === 'yes' || val === 'on') {
        GLOBAL_REPEAT_ENABLED = true;
      } else {
        GLOBAL_REPEAT_ENABLED = false;
      }
      p.remove();
      return;
    }

    // 2️⃣ klasické speed: alebo po ms:
    if (s.startsWith('speed:') || s.startsWith('po ms:') || s.startsWith('poms:')) {
      const parts = s.split(':');
      const val = parts[1] ? parseFloat(parts[1]) : NaN;
      if (Number.isFinite(val) && val >= 0) speedVal = val;
      p.remove();
      return;
    }
  });

  return speedVal;
}

let GLOBAL_FONT_FAMILY = null;

function readGlobalFont(doc) {
  const pList = Array.from(doc.querySelectorAll('p'));
  let fontUrl = null;

  for (const p of pList) {
    const raw = p.innerHTML.trim().replace(/&amp;/g, '&').replace(/<[^>]+>/g, '').trim();
    const match = raw.match(/font(?:link)?:\s*(https?:\/\/.+)$/i);
    if (match) {
      fontUrl = match[1].trim();
      p.remove();
      break;
    }
  }

  if (!fontUrl) return null;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = fontUrl;
  document.head.appendChild(link);

  const m = fontUrl.match(/family=([^:&]+)/);
  if (m) {
    const family = decodeURIComponent(m[1]).replace(/\+/g, ' ');
    GLOBAL_FONT_FAMILY = `'${family}', sans-serif`;
    //console.log(`🔤 Použitý font: ${GLOBAL_FONT_FAMILY}`);

    // 👇 Po načítaní fontu znova prepočítaj text vo všetkých fullscreen textoch
    document.fonts.ready.then(() => {
      document.querySelectorAll('.fullscreen-text').forEach(fitTextByWords);
    });
  }

  return fontUrl;
}



function extractTextColor(root) {
  // 1) Inline štýl (najspoľahlivejšie)
  const elInline = root.querySelector('[style*="color"]');
  if (elInline && elInline.style.color) return elInline.style.color;

  // 2) Gutenberg farby (has-text-color)
  const elClass = root.querySelector('.has-text-color, [class*="has-"][class*="-color"]');
  if (elClass) {
    return getComputedStyle(elClass).color;
  }

  return null;
}

function readBaseMs(doc, fallback=5000) {
  const ps = Array.from(doc.querySelectorAll('p'));
  for (const p of ps) {
    const s = p.innerText.trim().toLowerCase();
    if (s.startsWith('ms:')) {
      const v = parseFloat(s.slice(3));
      if (Number.isFinite(v) && v > 0) {
        p.remove();
        return v;
      }
    }
  }
  return fallback;
}


function readDurationAndSpeed(block, baseMs) {
  const ps = Array.from(block.querySelectorAll('p'));
  let stop = false;
  let bgValue = null;
  let durationMs = baseMs;
  let speedMs = null;
  let outlineColor = null;

  // Prehľadaj všetky <p> elementy v bloku
  ps.forEach(p => {
    const txt = (p.innerText || '').trim();
    const low = txt.toLowerCase();

    // STOP
    if (low === 'stop') {
      stop = true;
      p.remove();
      return;
    }

    // BG: (farba, gradient, obrázok)
    if (low.startsWith('bg:')) {
      bgValue = txt.slice(3).trim();
      p.remove();
      return;
    }

    // DURATION
    if (low.startsWith('ms:')) {
      const v = parseFloat(low.slice(3));
      if (Number.isFinite(v) && v > 0) durationMs = v;
      p.remove();
      return;
    } else if (/^\d+(\.\d+)?$/.test(low)) {
      const mult = parseFloat(low);
      if (Number.isFinite(mult) && mult > 0) durationMs = mult * baseMs;
      p.remove();
      return;
    }

    // SPEED
    if (low.startsWith('speed:')) {
      const v = parseFloat(low.slice(6));
      if (Number.isFinite(v) && v >= 0) {
        speedMs = v;
        p.remove();
        return;
      }
    }

    // COLOR
    if (low.startsWith('color:')) {
      outlineColor = txt.slice(6).trim();
      p.remove();
      return;
    }
  });

  return { durationMs, speedMs, stop, outlineColor, bgValue };
}





/* ==============================
   KONFIG PRE BUFFER/SLIDES
================================= */
const PREFETCH_AHEAD = 2;
const MIN_BUFFER_SEC_BASE = 0.5;
const MAX_BUFFER_SEC_BASE = 1.5;

function netBufferTargetSec() {
  const d = (navigator.connection && navigator.connection.downlink) || 5;
  const span = MAX_BUFFER_SEC_BASE - MIN_BUFFER_SEC_BASE;
  const t = MAX_BUFFER_SEC_BASE - Math.min((d / 5) * span, span);
  return Math.max(MIN_BUFFER_SEC_BASE, Math.min(MAX_BUFFER_SEC_BASE, t));
}

function hasPlayableBuffer(v, wantSec) {
  if (!v) return true;
  try {
    for (let i = 0; i < v.buffered.length; i++) {
      const from = v.buffered.start(i);
      const to = v.buffered.end(i);
      if (from <= 0 && to >= (wantSec || netBufferTargetSec())) return true;
    }
  } catch (e) {}
  return v.readyState >= 2;
}

function attachSrcIfNeeded(v) {
  if (!v) return;
  if (!v.getAttribute('src') && v.dataset && v.dataset.src) {
    v.setAttribute('src', v.dataset.src);
  }
}

function detachSrc(v) {
  if (!v) return;
  const s = v.getAttribute('src');
  if (s) {
    if (s.startsWith('blob:')) {
      try { URL.revokeObjectURL(s); } catch (e) {}
    }
    v.removeAttribute('src');
    v.load();
    v.dataset.src = s;
  }
}

function prepVideoBasics(v) {
  if (!v) return;
  
  // zachová pôvodné nastavenie z WP
  const wasMuted = v.hasAttribute('muted') || v.muted;

  v.playsInline = true;
  v.setAttribute('playsinline', '');
  v.preload = 'auto';

  // len ak bolo pôvodne muted → nech ostane tiché
  v.muted = wasMuted;
  if (wasMuted) {
    v.setAttribute('muted', '');
  } else {
    v.removeAttribute('muted');
  }
}

function prebufferVideo(v, wantSec) {
  return new Promise((resolve) => {
    if (!v) return resolve();
    attachSrcIfNeeded(v);
    prepVideoBasics(v);

    if (hasPlayableBuffer(v, wantSec)) return resolve();

    const onCanPlay = () => {
      v.removeEventListener('canplay', onCanPlay);
      v.removeEventListener('canplaythrough', onCanPlay);
      resolve();
    };
    v.addEventListener('canplay', onCanPlay, { once: true });
    v.addEventListener('canplaythrough', onCanPlay, { once: true });

    v.play().then(() => {
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    }).catch(() => {});

    setTimeout(resolve, 1800);
  });
}

let navLock = false;
function withNavLock(fn) {
 // if (navLock || !detailSwiper || detailSwiper.animating) return; Nezablokuj navigáciu počas fade
  navLock = true;
  Promise.resolve(fn()).finally(() => setTimeout(() => { navLock = false; }, 50));
}

async function slidePrevPrepared(sw) {
  if (!sw) return;
  resetAutoplay(sw); 
  const prevIdx = sw.activeIndex - 1;
  const prev = sw.slides[prevIdx];
  if (!prev) { closeDetail(); return; }

  const v = prev.querySelector('video');
  await prebufferVideo(v);

  const speed = prev.dataset && prev.dataset.speed ? parseInt(prev.dataset.speed, 10) : 1000;
  sw.params.speed = speed;
  sw.update();
  sw.slideTo(prevIdx);

  requestAnimationFrame(() => {
    const cur = sw.slides[sw.activeIndex];
    const curVid = cur ? cur.querySelector('video') : null;
    if (curVid) safeStartVideo(sw, curVid);
  });

  warmupAhead(sw, PREFETCH_AHEAD);
  trimVideoAttachments(sw);
}


function playFromStartInstant(v) {
  if (!v) return;
  attachSrcIfNeeded(v);
  prepVideoBasics(v);
  const go = () => {
    try { v.currentTime = 0; } catch (e) {}
    const p = v.play();
    if (p && typeof p.then === 'function') p.catch(() => {});
  };
  if (v.readyState >= 2) {
    go();
  } else {
    const onMeta = () => { v.removeEventListener('loadedmetadata', onMeta); go(); };
    v.addEventListener('loadedmetadata', onMeta, { once: true });
    try { v.load(); } catch (e) {}
  }
}

function trimVideoAttachments(sw) {
  const i = sw.activeIndex;
  sw.slides.forEach((sl, idx) => {
    const v = sl.querySelector('video');
    if (!v) return;
    if (Math.abs(idx - i) <= 2) {  // bolo <= 1
      attachSrcIfNeeded(v);
      prepVideoBasics(v);
    } else {
      detachSrc(v);
    }
  });
}

async function warmupAhead(sw, n) {
  if (!sw) return;
  const i = sw.activeIndex;
  const promises = [];
  for (let k = 1; k <= (n || PREFETCH_AHEAD); k++) {
    const s = sw.slides[i + k];
    if (!s) break;
    const v = s.querySelector('video');
    promises.push(prebufferVideo(v));
  }
  await Promise.all(promises);


}

let _lastStart = { slideIdx: -1, at: 0 };

function safeStartVideo(sw, vid) {
  if (!vid) return;
  const now = performance.now();
  const idx = sw.activeIndex;

  // Základ podľa rýchlosti prechodu (Swiper speed + slide dataset.speed)
  const speedFromSw   = (sw && sw.params && sw.params.speed) ? Number(sw.params.speed) : 0;
  const slideEl       = sw && sw.slides ? sw.slides[idx] : null;
  const speedFromData = slideEl && slideEl.dataset && slideEl.dataset.speed ? Number(slideEl.dataset.speed) : 0;

  // Použi najväčšie relevantné + malý buffer
  const minGap = Math.max(800, speedFromSw, speedFromData) + 120;

  // Debounce per-VIDEO (spoľahlivejšie než per-slide)
  const lastTs = Number(vid.dataset.lastStartTs || 0);
  if (now - lastTs < minGap) return;

  vid.dataset.lastStartTs = String(now);
  _lastStart.slideIdx = idx;
  _lastStart.at = now;

  playFromStartInstant(vid);
}

async function slideNextPrepared(sw, {instant=false} = {}) {
  if (!sw) return;
  resetAutoplay(sw); 
  const nextIdx = sw.activeIndex + 1;
  const next = sw.slides[nextIdx];
  if (!next) { closeDetail(); return; }

  const v = next.querySelector('video');

  if (!instant) {
    // autoplay → najprv nech si bufferne
    await prebufferVideo(v);
  } else {
    // manuálna šípka → buffer beží na pozadí
    prebufferVideo(v);
  }

  const speed = next.dataset?.speed
    ? parseInt(next.dataset.speed, 10)
    : (sw.params?.speed ?? 800);

  sw.params.speed = speed;
  sw.update();
  sw.slideTo(nextIdx);

  requestAnimationFrame(() => {
    const curVid = sw.slides[sw.activeIndex]?.querySelector('video');
    if (curVid) safeStartVideo(sw, curVid);
  });

  warmupAhead(sw, PREFETCH_AHEAD);
  trimVideoAttachments(sw);
}



function getNextSpeed(sw) {
  const i = sw.activeIndex;
  const next = sw.slides[i + 1];

  // preferuj per-slide, ak neexistuje globál
  if (GLOBAL_SPEED_MS == null) {
    const ds = next?.dataset?.speed;
    if (ds != null && ds !== '') return parseFloat(ds);
  }
  if (GLOBAL_SPEED_MS != null) return GLOBAL_SPEED_MS;

  // fallback
  if (sw.params && Number.isFinite(sw.params.speed)) return sw.params.speed;
  return 800;
}

function resetAutoplay(sw) {
  if (!sw) return;
  if (sw.nextTimeout) {
    clearTimeout(sw.nextTimeout);
    sw.nextTimeout = null;
  }
}

let slideStartAt = 0;      // čas, keď sa slide začal ZOBRAZOVAŤ (po fade)
let slideStartIdx = -1;

function scheduleNextSlideControlled() {
  if (!detailSwiper) return;

  if (!GLOBAL_AUTOPLAY_ENABLED) {
    return; // 🔒 autoplay je vypnutý → nič neplánujeme
  }

  const now = performance.now();
  const i = detailSwiper.activeIndex;              // 👈 definuj i
  const active = detailSwiper.slides[i];
  if (!active) return;

  if (active.dataset?.stop === '1') {
    return;
  }

  const duration = active.dataset?.duration ? parseFloat(active.dataset.duration) : 5000;

  const elapsed   = Math.max(0, now - slideStartAt);
  const remaining = Math.max(0, duration - elapsed);

  clearTimeout(detailSwiper.nextTimeout);

  const isLast = i >= detailSwiper.slides.length - 1;
  if (isLast) {
    detailSwiper.nextTimeout = setTimeout(() => {
      // 🔸 Ak je repeat vypnutý → zavri detail a prejdi na ďalší článok
      if (!GLOBAL_REPEAT_ENABLED) {
        closeDetail();
  
        setTimeout(() => {
          if (articleSwiper) {
            const nextIdx = articleSwiper.activeIndex + 1;
            if (nextIdx < articleSwiper.slides.length) {
              articleSwiper.slideTo(nextIdx);
            } else {
              // 🔁 Ak bol posledný článok, vráť sa na prvý
              articleSwiper.slideTo(0);
            }
          }
        }, 800); // počkaj, kým sa detail zatvorí (fade)
        return;
      }
  
      // 🔁 Ak je repeat zapnutý → prejdi naspäť na prvý slide
      const speed = getSpeedForIndex(detailSwiper, 0);
      detailSwiper.params.speed = speed;
      detailSwiper.update();
      detailSwiper.slideTo(0);
    }, remaining);
    return;
  }

  const nextIdx   = i + 1;
  const nextSpeed = getSpeedForIndex(detailSwiper, nextIdx);
  const delay     = Math.max(0, remaining - nextSpeed);

  detailSwiper.nextTimeout = setTimeout(async () => {
    detailSwiper.params.speed = nextSpeed;
    detailSwiper.update();

    const v = detailSwiper.slides[nextIdx]?.querySelector('video');
    await prebufferVideo(v);

    detailSwiper.slideTo(nextIdx);
  }, delay);
}


/* ==============================
   UI helpery – text / layout
================================= */
function fitTextByWords(el) {
  if (!el) return;

  const ps = el.querySelectorAll('p, h1, h2, h3, h4, h5, h6');
  const targets = ps.length ? Array.from(ps) : [el];  

  const minVW = 2.5;
  const maxVW = 14;

  const applyFont = (vw) => {
    targets.forEach((p) => {
      p.style.fontSize = vw + 'vw';
      p.style.lineHeight = '1.1';
      p.style.wordBreak = 'break-word';
      p.style.textAlign = 'center';
      p.style.margin = '0.25em 0';
    });

    // 🆕 Zmenši font-size pre blockquote (napr. o 20 %)
    const quotes = el.querySelectorAll('blockquote');
quotes.forEach((q) => {
  // citácia ako celok
  q.style.opacity = '0.9';
  q.style.marginTop = '0.8em';
  q.style.lineHeight = '1.25';

  // zmenši vnútorné texty (p, span, atď.)
  const innerTexts = q.querySelectorAll('p, span, strong, em');
  innerTexts.forEach((node) => {
    node.style.fontSize = (vw * 0.5) + 'vw'; // -50 %
    node.style.lineHeight = '1.25';
  });
});
  };

  const containerH = el.clientHeight * 0.96;
  const containerW = el.clientWidth * 0.96;

  let low = minVW;
  let high = maxVW;
  let best = low;
  let guard = 0;

  while (low <= high && guard < 40) {
    guard++;
    const mid = (low + high) / 2;
    applyFont(mid);

    const pRects = Array.from(ps).map(p => p.getBoundingClientRect());
    const top = Math.min(...pRects.map(r => r.top));
    const bottom = Math.max(...pRects.map(r => r.bottom));
    const contentH = bottom - top;
    const contentW = Math.max(...pRects.map(r => r.width));

    if (contentH > containerH * 0.98 || contentW > containerW * 0.98) {
      high = mid - 0.1;
    } else {
      best = mid;
      low = mid + 0.1;
    }
  }

  applyFont(best);
}





function refitActiveSlide(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  if (!activeSlide) return;
  const textBox = activeSlide.querySelector('.fullscreen-text');
  if (textBox) fitTextByWords(textBox);
}

function calcWaveDuration(msPerTakt, targetSec) {
  const oneBeat = msPerTakt / 4;
  const targetMs = (targetSec || 36) * 1000;
  const beatCount = Math.round(targetMs / oneBeat);
  return (oneBeat * beatCount) / 1000;
}



function wrapWordsInSpans(element, msPerTakt, resolvedColor) {
  if (!element) return;

  // zachová vnútorné HTML tagy, ale spracuje textové uzly
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
  const textNodes = [];
  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach((node) => {
    const words = node.textContent.split(/\s+/).filter(Boolean);
    if (words.length === 0) return;

    const frag = document.createDocumentFragment();
    words.forEach((word, i) => {
      const span = document.createElement('span');
      span.textContent = word;
      span.style.display = 'inline-block';
      span.style.marginRight = '0.3em';
      if (resolvedColor) span.style.color = resolvedColor;
      frag.appendChild(span);
    });

    node.parentNode.replaceChild(frag, node);
  });
}

function cancelFade(a) {
  if (!a) return;
  if (a._fadeRAF) { cancelAnimationFrame(a._fadeRAF); a._fadeRAF = null; }
}

function fadeTo(audio, toVol, duration = 600, { pauseAtEnd=false, resetAtEnd=false } = {}) {
  return new Promise(resolve => {
    if (!audio) return resolve();

    cancelFade(audio);

    const startVol = clamp01(audio.volume);
    const target   = clamp01(toVol);
    const start    = performance.now();

    const step = (now) => {
      const t = clamp01((now - start) / Math.max(1, duration));  // 0..1
      const v = startVol + (target - startVol) * t;
      setVol(audio, v);

      if (t < 1) {
        audio._fadeRAF = requestAnimationFrame(step);
      } else {
        audio._fadeRAF = null;
        setVol(audio, target);                // finálne zarovnanie
        if (pauseAtEnd) audio.pause();
        if (resetAtEnd) { try { audio.currentTime = 0; } catch(_) {} }
        resolve();
      }
    };

    audio._fadeRAF = requestAnimationFrame(step);
  });
}


function crossfadeAudios(outA, inA, duration = 600) {
  if (!outA || !inA) return;
  cancelFade(outA);
  cancelFade(inA);
  inA.volume = 0;
  inA.play().catch(()=>{});
  const start = performance.now();
  const tick = (now) => {
    const t = Math.min(1, (now - start) / duration);
    outA.volume = 1 - t;
    inA.volume  = t;
    if (t < 1) {
      inA._fadeRAF = outA._fadeRAF = requestAnimationFrame(tick);
    } else {
      inA._fadeRAF = outA._fadeRAF = null;
      outA.pause();
      outA.currentTime = 0;
      outA.volume = 1;
      inA.volume = 1;
    }
  };
  inA._fadeRAF = outA._fadeRAF = requestAnimationFrame(tick);
}
const FADE_MS = 1000;
let currentAudio = null;
let xfSession   = 0;

function ensureSingleAudio(keep) {
  const audios = contentDiv.querySelectorAll('audio');
  audios.forEach(a => {
    if (a !== keep) {
      cancelFade(a);        // zruš prípadný rozbehnutý fade
      a.volume = 0;         // okamžitý „duck“ → žiadne prekrývanie
      a.pause();
      try { a.currentTime = 0; } catch(e) {}
    }
  });
}



function getCurrentlyPlayingAudio() {
  const list = contentDiv.querySelectorAll('audio');
  for (const a of list) {
    if (!a.paused && !a.ended && a.readyState >= 2 && a.volume > 0) {
      return a;
    }
  }
  return null;
}

function hardSilenceExcept(keepList = []) {
  const keep = new Set(keepList.filter(Boolean));
  contentDiv.querySelectorAll('audio').forEach(a => {
    if (!keep.has(a)) {
      cancelFade(a);
      setVol(a, 0);
      a.pause();
      try { a.currentTime = 0; } catch(_) {}
    }
  });
} 

function clamp01(x) {
  return Math.min(1, Math.max(0, Number.isFinite(x) ? x : 0));
}
function setVol(media, v) {
  if (!media) return;
  media.volume = clamp01(v);
}

function crossfadeTo(nextAudio) {
  xfSession += 1;
  const mySession = xfSession;

  // necháme len aktuálne + nové (ostatné stop)
  hardSilenceExcept([currentAudio, nextAudio]);

  // priprav nové audio – hneď naplno
  cancelFade(nextAudio);
  try { nextAudio.currentTime = 0; } catch(_) {}
  setVol(nextAudio, 1);
  nextAudio.play().catch(()=>{});

  // ak nič nehralo predtým → len nastav currentAudio a skonči
  if (!currentAudio || currentAudio === nextAudio) {
    currentAudio = nextAudio;
    return;
  }

  // fade-out len pre staré audio
  const oldA = currentAudio;
  cancelFade(oldA);
  fadeTo(oldA, 0, FADE_MS, { pauseAtEnd: true, resetAtEnd: true })
    .then(() => {
      if (mySession !== xfSession) return;
      hardSilenceExcept([nextAudio]);
    });

  currentAudio = nextAudio;
}




/* ==============================
   ČLÁNKY – prvý Swiper
================================= */
function initArticleSwiper(posts) {
  const wrapper = articleContainer.querySelector('.swiper-wrapper');
  wrapper.innerHTML = '';

  posts.forEach((post) => {
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');

    let imageUrl = '';
    if (post._embedded && post._embedded['wp:featuredmedia']) {
      imageUrl = post._embedded['wp:featuredmedia'][0].source_url;
    }

    

    slide.innerHTML = (
      '<div class="post-slide" style="background-image: url(\'' + imageUrl + '\')">' +
        '<h3 class="post-title">' + post.title.rendered + '</h3>' +
      '</div>'
    );

    const postSlide = slide.querySelector('.post-slide');

    if (imageUrl) {
      const img = new Image();
      img.src = imageUrl;
      img.onload = function () {
        postSlide.classList.add('loaded');
      };
    } else {
      postSlide.classList.add('loaded');
    }

    postSlide.addEventListener('click', function () {
      openDetail(post);
    });

    wrapper.appendChild(slide);
  });

  articleSwiper = new Swiper('#article-swiper', {
    modules: [Navigation, Pagination, EffectFade, Mousewheel],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
    speed: 1000,
    mousewheel: { forceToAxis:false, releaseOnEdges: true },
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
  });
}

/* ==============================
   DETAIL – druhý Swiper
================================= */

function readGlobalColor(doc, fallback=null){
  // nájdi <p> s "color: ..." alebo samotnú farbu v jednom <p>
  const ps = Array.from(doc.querySelectorAll('p'));

  function isCssColor(val){
    if (!val) return false;
    const s = String(val).trim();
    if (!s) return false;
    if (window.CSS && CSS.supports && CSS.supports('color', s)) return true;
    const opt = new Option().style;
    opt.color = '';
    opt.color = s;
    return opt.color !== '';
  }

  const COLOR_RE = /color\s*:\s*(.+)$/i;

  // 1) p so zápisom "color: ..."
  for (const p of ps) {
    const raw = (p.textContent || '').replace(/\u200B|\uFEFF/g, '').trim();
    const m = raw.match(COLOR_RE);
    if (m && isCssColor(m[1])) {
      p.remove();
      return m[1].trim();
    }
  }

  // 2) p obsahujúci len holú farbu (#fff, red, rgb(...))
  for (const p of ps) {
    const raw = (p.textContent || '').replace(/\u200B|\uFEFF/g, '').trim();
    if (isCssColor(raw)) {
      p.remove();
      return raw;
    }
  }

  return fallback;
}



function openDetail(post) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(post.content.rendered, 'text/html');
  const blocks = doc.querySelectorAll('.wp-block-column');

  const columnHasBgc = new WeakMap();
  const specialClasses = new WeakMap();
  doc.querySelectorAll('.wp-block-columns').forEach(cols => {
    const clsList = Array.from(cols.classList);
    const specials = clsList.filter(c => ['bgc', 'kb','trt' ].includes(c));
    if (specials.length > 0) {
      cols.querySelectorAll('.wp-block-column').forEach(col => {
        specialClasses.set(col, specials);
      });
    }
  });
  contentDiv.innerHTML = (
    '<div class="swiper detail-swiper">' +
      '<div class="swiper-wrapper"></div>' +
      '<div class="swiper-button-next"></div>' +
      '<div class="swiper-button-prev"></div>' +
      '<div class="swiper-pagination"></div>' +
    '</div>'
  );

  const detailWrapper = contentDiv.querySelector('.swiper-wrapper');

  let baseDuration = readBaseMs(doc, 5000);
  GLOBAL_SPEED_MS  = readGlobalSpeed(doc, null);
  if (!GLOBAL_AUTOPLAY_ENABLED) {
   
  }
  const GLOBAL_OUTLINE_COLOR = readGlobalColor(doc, null);
  const GLOBAL_FONT_URL = readGlobalFont(doc);

  setTimeout(() => {
   // console.log('⏳ Refit text po načítaní fontu...');
    document.querySelectorAll('.fullscreen-text').forEach(fitTextByWords);
  }, 1200);  

  // 👇 NEW: seed z featured image (ak je) a drž si posledný obrázok
  const featuredFallback =
    (post._embedded && post._embedded['wp:featuredmedia'] &&
     post._embedded['wp:featuredmedia'][0] &&
     post._embedded['wp:featuredmedia'][0].source_url) || '';
  let lastBgUrl = featuredFallback;
  

  blocks.forEach((block) => {
    const ps = block.querySelectorAll('p');

    const { durationMs, speedMs, stop, outlineColor, bgValue } = readDurationAndSpeed(block, baseDuration);
const resolvedOutlineColor = outlineColor || extractTextColor(block) || GLOBAL_OUTLINE_COLOR || "silver";

const duration = durationMs;
const speed    = speedMs;

    

    const blockClone = block.cloneNode(true);
    blockClone.querySelectorAll('figure, .wp-block-gallery').forEach(function (el) { el.remove(); });
    const text = blockClone.innerHTML;

    const audioEl = block.querySelector('audio');
    if (audioEl) audioEl.style.display = 'none';

    const videoFigure = block.querySelector('figure.wp-block-video');
    if (videoFigure) {
      const videoEl = videoFigure.querySelector('video');
      if (videoEl) {
        videoEl.removeAttribute('controls');
        videoEl.loop = true;
        
        videoEl.playsInline = true;
        // nechaj, či má alebo nemá byť muted podľa WordPressu
const wasMuted = videoEl.hasAttribute('muted') || videoEl.muted;
videoEl.muted = wasMuted;
if (wasMuted) {
  videoEl.setAttribute('muted', '');
} else {
  videoEl.removeAttribute('muted');
}
        videoEl.setAttribute('playsinline', '');
        if (videoEl.src) {
          videoEl.dataset.src = videoEl.src;
          videoEl.removeAttribute('src');
          videoEl.preload = 'metadata';
        }

        

        const slide = document.createElement('div');
        slide.classList.add('swiper-slide');
        slide.dataset.duration = String(duration);
       
        if (GLOBAL_SPEED_MS == null && speed != null) {
          slide.dataset.speed = String(speed);
        } else {
          delete slide.dataset.speed; // budeme používať globál
        }
        if (stop) slide.dataset.stop = '1'; else delete slide.dataset.stop;
       

        if (audioEl) slide.appendChild(audioEl);

        const wrapper = document.createElement('div');
        wrapper.classList.add('fullscreen-video');
        
        // prenes špeciálne triedy (bgc, kb, atď.)
        const extra = specialClasses.get(block);
        if (extra) extra.forEach(cls => wrapper.classList.add(cls));
        
        // 🎬 ak má triedu "bgc", nastav fullscreen štýl
        if (wrapper.classList.contains('bgc')) {
          wrapper.style.position = 'fixed';
          wrapper.style.inset = '0';
          wrapper.style.width = '100vw';
          wrapper.style.height = '100vh';
          
          wrapper.style.zIndex = '-1';
          wrapper.style.pointerEvents = 'none';
        } else {
          // inak klasické centrálne video
          wrapper.style.width = '90%';
          wrapper.style.height = '90%';
          wrapper.style.margin = 'auto';
          wrapper.style.display = 'flex';
          wrapper.style.alignItems = 'center';
          wrapper.style.justifyContent = 'center';
          
        }

        wrapper.appendChild(videoEl);

        if (text.trim() !== '') {
          const textWrapper = document.createElement('div');
          if (GLOBAL_FONT_FAMILY) {
            textWrapper.style.fontFamily = GLOBAL_FONT_FAMILY;
          }
          textWrapper.classList.add('fullscreen-text'); 

          const extra = specialClasses.get(block);
          if (extra) extra.forEach(cls => textWrapper.classList.add(cls));
          
          textWrapper.innerHTML = text;
          textWrapper.querySelectorAll('p').forEach(function (p) { wrapWordsInSpans(p, duration, resolvedOutlineColor); });
          wrapper.appendChild(textWrapper);
          requestAnimationFrame(() => fitTextByWords(textWrapper));
        }

        slide.appendChild(wrapper);
        detailWrapper.appendChild(slide);  
        
      }
      return;
    }

    const gallery = block.querySelector('.wp-block-gallery');
    if (gallery) {
      const imgs = gallery.querySelectorAll('img');
      imgs.forEach((img, i) => {
        const slide = document.createElement('div');
        slide.classList.add('swiper-slide');
        slide.dataset.duration = String(duration);
if (GLOBAL_SPEED_MS == null && speed != null) {
  slide.dataset.speed = String(speed);
} else {
  delete slide.dataset.speed; // používame globál alebo nič
}
if (stop) slide.dataset.stop = '1'; else delete slide.dataset.stop;

        if (audioEl && i === 0) slide.appendChild(audioEl);

        const textWrapper = document.createElement('div');
        if (GLOBAL_FONT_FAMILY) {
          textWrapper.style.fontFamily = GLOBAL_FONT_FAMILY;
        }
        textWrapper.classList.add('fullscreen-text');
        const extra = specialClasses.get(block);
if (extra) extra.forEach(cls => textWrapper.classList.add(cls));
      
        textWrapper.innerHTML = text;
        textWrapper.querySelectorAll('p').forEach(function (p) { wrapWordsInSpans(p, duration, resolvedOutlineColor); });

        const bg = (img && img.src) || lastBgUrl || featuredFallback;
        if (bg) textWrapper.style.setProperty('--bg-image', `url(${bg})`);
        lastBgUrl = bg;

        // 🔳 Pozadie slidu z "bg:" alebo z obrázka / gradientu

        let bgStyle = null;

// 🆕 Získaj farbu pozadia z rodičovskej .wp-block-columns (rovnako ako pri texte)
const parentCols = block.closest('.wp-block-columns');
if (parentCols?.style?.background && parentCols.style.background.trim() !== '') {
  bgStyle = parentCols.style.background.trim();
} else if (parentCols?.style?.backgroundColor && parentCols.style.backgroundColor.trim() !== '') {
  bgStyle = parentCols.style.backgroundColor.trim();
}

if (textWrapper.classList.contains('trt')) {
  // 🎯 Ak je to TRTextový slide (background-clip text)
  if (bg) {
    textWrapper.style.setProperty('--bg-image', `url(${bg})`);
  }

  // 🆕 pridaj farbu alebo gradient pre okolie textu
  if (bgValue) {
    textWrapper.style.setProperty('--bg-color', bgValue);
  } else if (bgStyle) {
    textWrapper.style.setProperty('--bg-color', bgStyle);
  } else {
    textWrapper.style.setProperty('--bg-color', '#000');
  }

  // odstráň inline background (nesmie byť!)
  textWrapper.style.removeProperty('background');

} else {
  // 🌄 bežné slidy idú po starom
  const useCover = textWrapper.classList.contains('bgc');

if (bgValue) {
  textWrapper.style.background = bgValue;
} else if (bg && bgStyle) {
  // kombinácia: obrázok + farba pod ním
  textWrapper.style.background = `${bgStyle}, url(${bg}) center center / ${useCover ? 'cover' : 'contain'} no-repeat`;
} else if (bg) {
  textWrapper.style.background = `url(${bg}) center center / ${useCover ? 'cover' : 'contain'} no-repeat`;
} else if (bgStyle) {
  textWrapper.style.background = bgStyle;
} else {
  textWrapper.style.background = '#000';
}
}

        slide.appendChild(textWrapper);
        detailWrapper.appendChild(slide);

        requestAnimationFrame(() => fitTextByWords(textWrapper));

      });

      gallery.remove();
    } else {


      const figure = block.querySelector('figure');
      let img = null;
      if (figure) {
        img = figure.querySelector('img');
        figure.remove();
      }

      // Skús získať background color zo štýlu Gutenberg bloku
// Skús získať background (aj gradient) zo štýlu Gutenberg bloku
let bgStyle = null;

const parentCols = block.closest('.wp-block-columns');
if (parentCols?.style?.background && parentCols.style.background.trim() !== '') {
  bgStyle = parentCols.style.background.trim(); // linear-gradient, color, atď.
} else if (block.style?.background && block.style.background.trim() !== '') {
  bgStyle = block.style.background.trim();
} else if (parentCols?.style?.backgroundColor && parentCols.style.backgroundColor.trim() !== '') {
  bgStyle = parentCols.style.backgroundColor.trim();
}

// Odstráni nepotrebné ; ak by tam bolo
if (bgStyle) bgStyle = bgStyle.replace(/;$/, '');

      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      slide.dataset.duration = String(duration);
if (GLOBAL_SPEED_MS == null && speed != null) {
  slide.dataset.speed = String(speed);
} else {
  delete slide.dataset.speed;
}
if (stop) slide.dataset.stop = '1'; else delete slide.dataset.stop;
      if (audioEl) slide.appendChild(audioEl);

      const textWrapper = document.createElement('div');
      if (GLOBAL_FONT_FAMILY) {
        textWrapper.style.fontFamily = GLOBAL_FONT_FAMILY;
      }
      textWrapper.classList.add('fullscreen-text');
      const extra = specialClasses.get(block);
if (extra) extra.forEach(cls => textWrapper.classList.add(cls));
     

      textWrapper.innerHTML = text;
      textWrapper.querySelectorAll('p').forEach(function (p) { wrapWordsInSpans(p, duration, resolvedOutlineColor); });

      let bg = '';
      if (img && img.src) {
        bg = img.src;
        lastBgUrl = img.src;
      } else {
        bg = lastBgUrl || featuredFallback;
      }
      
      if (textWrapper.classList.contains('trt')) {
        // 🎯 Ak je to TRTextový slide (background-clip text)
        if (bg) {
          textWrapper.style.setProperty('--bg-image', `url(${bg})`);
        }
      
        // 🆕 pridaj farbu alebo gradient pre okolie textu
        if (bgValue) {
          textWrapper.style.setProperty('--bg-color', bgValue);
        } else if (bgStyle) {
          textWrapper.style.setProperty('--bg-color', bgStyle);
        } else {
          textWrapper.style.setProperty('--bg-color', '#000');
        }
      
        // odstráň inline background (nesmie byť!)
        textWrapper.style.removeProperty('background');
      
      } else {
        // 🌄 bežné slidy idú po starom
        if (bgValue) {
          textWrapper.style.background = bgValue;
        } else if (bgStyle) {
          textWrapper.style.background = bgStyle;
        } else if (bg) {
          textWrapper.style.setProperty('--bg-image', `url(${bg})`);
          textWrapper.style.background = bgStyle || 'transparent';
        } else {
          textWrapper.style.background = '#000';
        }
      }
      
      slide.appendChild(textWrapper);
      detailWrapper.appendChild(slide);

      requestAnimationFrame(() => fitTextByWords(textWrapper));
    }
  });

  detailSwiper = new Swiper('.detail-swiper', {
    modules: [Navigation, Pagination, EffectFade, Mousewheel],
    effect: 'fade',
    fadeEffect: { crossFade: true },
    slidesPerView: 1,
    mousewheel: { forceToAxis: false, releaseOnEdges: true },
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    speed: GLOBAL_SPEED_MS ?? 1800,
    on: {
      init: function (sw) {
        warmupAhead(sw, PREFETCH_AHEAD);
        trimVideoAttachments(sw);
        slideStartAt = performance.now();
    slideStartIdx = sw.activeIndex;
    if (sw.nextTimeout) { clearTimeout(sw.nextTimeout); sw.nextTimeout = null; }
    setTimeout(() => {
      scheduleNextSlideControlled();
    }, 1500); 
    clearTimeout(sw._vidStartTimer);
    sw._vidStartTimer = setTimeout(() => startActiveVideoNow(sw), 1000);
    
    // ←← PRIDAJ TOTO PO init-e:
    const btnNext = contentDiv.querySelector('.swiper-button-next');
    const btnPrev = contentDiv.querySelector('.swiper-button-prev');
    btnNext?.addEventListener('click', (ev) => { ev.preventDefault(); navImmediate(detailSwiper, +1); });
    btnPrev?.addEventListener('click', (ev) => { ev.preventDefault(); navImmediate(detailSwiper, -1); });

    updateEdgeLock(sw);
      },

      slideChange(sw) {
        clearTimeout(sw._vidStartTimer);
        sw._vidStartTimer = setTimeout(() => startActiveVideoNow(sw), 1000);
      },


      transitionStart: function (sw) {
        const leaving  = sw.previousIndex >= 0 ? sw.slides[sw.previousIndex] : null;
        const entering = sw.slides[sw.activeIndex] || null;
      
        // video obsluha (ako máš)
        if (leaving) {
          leaving.querySelectorAll('video').forEach(v => {
            try {
              v.pause();
              setTimeout(() => {
                try { v.currentTime = 0; } catch (_) {}
              }, 2000);
            } catch (e) {}
          });
        }
        if (entering) entering.querySelectorAll('video').forEach(v => attachSrcIfNeeded(v));
      
        // 🔊 AUDIO – jemný crossfade, nikdy viac než 2 naraz
        const nextAudio = entering ? entering.querySelector('audio') : null;
      
        if (nextAudio) {
          // slide s audiom → jemný crossfade (staré dole, nové hore)
          crossfadeTo(nextAudio);
        } else {
          // tichý slide → ak audio dohralo, už ho nespúšťaj
          if (currentAudio) {
            if (currentAudio.ended || currentAudio.currentTime >= currentAudio.duration - 0.3) {
              // úplne zastav predošlé audio, už dohralo
              hardSilenceExcept([]);
              currentAudio = null;
              xfSession += 1;
            } else {
              // stále hrá alebo loopuje → nech dohrá
              hardSilenceExcept([currentAudio]);
            }
          } else {
            hardSilenceExcept([]);
          }
        }
        
      },
      
      
      transitionEnd: function (sw) {

        slideStartAt = performance.now();
        slideStartIdx = sw.activeIndex;

        const cur = sw.slides[sw.activeIndex];
        const v = cur?.querySelector('video');
        if (v && (v.paused || v.currentTime === 0)) {
          // ak by náhodou nestartlo skôr
          startActiveVideoNow(sw);
        }
      
        warmupAhead(sw, PREFETCH_AHEAD);
        trimVideoAttachments(sw);
        if (sw.nextTimeout) { clearTimeout(sw.nextTimeout); sw.nextTimeout = null; }
    scheduleNextSlideControlled();
    updateEdgeLock(sw);
  }
      
      
    }
  });

  window.addEventListener('resize', function () {
    if (detailSwiper) refitActiveSlide(detailSwiper);
  });


  
  articleContainer.classList.add('hidden');
  setTimeout(function () {
    articleContainer.style.visibility = 'hidden';
    contentDiv.classList.add('active');
    isDetailView = true;
  }, 1600);

  setTimeout(() => {
    closeDetailBtn.style.display = 'block';
  }, 1000);

}

function startActiveVideoNow(sw) {
  if (!sw) return;
  const cur = sw.slides[sw.activeIndex];
  if (!cur) return;
  const v = cur.querySelector('video');
  if (!v) return;

  attachSrcIfNeeded(v);
  prepVideoBasics(v);
  // okamžité spustenie od 0:
  try { v.currentTime = 0; } catch (e) {}
  const p = v.play();
  if (p && typeof p.then === 'function') p.catch(()=>{});
}

function stopAllAudioImmediate(scope = document) {
  const audios = scope.querySelectorAll('audio');
  audios.forEach(a => {
    cancelFade(a);               // zruš rozbehnuté fadovanie
    try { a.pause(); } catch(_) {}
    try { a.currentTime = 0; } catch(_) {}
    a.volume = 1;                // vynuluj stav (nech ďalšie prehrávanie začne normálne)
  });
  currentAudio = null;           // zruš referenciu pre crossfade logiku
  xfSession += 1;                // ukonči prípadné prebiehajúce crossfade-y
}

/* ==============================
   Zatváranie detailu
================================= */

function closeDetail() {

  stopAllAudioImmediate(contentDiv); 
  currentAudio = null; 
  xfSession += 1; // ukonči prebiehajúce crossfade-y
  

  contentDiv.style.transition = 'opacity 0.5s ease';
  contentDiv.style.opacity = '0'; // spusti fade-out

  closeDetailBtn.style.display = 'none';

  setTimeout(() => {
    articleContainer.classList.remove('hidden');
    articleContainer.style.visibility = 'visible';
    contentDiv.innerHTML = '';
    if (detailSwiper && typeof detailSwiper.destroy === 'function') {
      detailSwiper.destroy(true, true);
    }
    detailSwiper = null;
    isDetailView = false;
    contentDiv.style.opacity = ''; // reset
  }, 500); // po fade-oute vyčisti
}


/* ==============================
   Klávesnica / ovládanie
================================= */
let autoplayEnabled = true;
let lastClickTime = null;

document.addEventListener('keydown', function (e) {
  if (e.key && e.key.toLowerCase() === 's' && isDetailView) {
    GLOBAL_AUTOPLAY_ENABLED = !GLOBAL_AUTOPLAY_ENABLED;
  
    if (!GLOBAL_AUTOPLAY_ENABLED) {
      clearTimeout(detailSwiper?.nextTimeout);
      
    } else {
      
      scheduleNextSlideControlled();
    }
  }

 // ignoruj auto-repeat z podržanej klávesy
 if (e.repeat) return;

 // zabráň posúvaniu stránky
 if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();

 // klávesnica
 if (isDetailView && detailSwiper) {
  if (e.key === 'ArrowDown') navImmediate(detailSwiper, +1);
  if (e.key === 'ArrowUp')   navImmediate(detailSwiper, -1);
}

// ČLÁNKY (articleSwiper) – keď nie si v detaile
// ČLÁNKY (articleSwiper) – keď nie si v detaile
if (!isDetailView && articleSwiper) {
  // spracuj šípky a ukonči len keď sa naozaj použili
  if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
    e.preventDefault();           // nech to neposúva stránku/nescrolluje
    articleSwiper.slideNext();
    return;
  }
  if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
    e.preventDefault();
    articleSwiper.slidePrev();
    return;
  }
  // ak to nebola šípka, nevracaj sa – nech sa nižšie spracuje Enter
}



  if (e.key && e.key.toLowerCase() === 'p') {
    const now = performance.now();
    if (lastClickTime !== null) {
      const diff = now - lastClickTime;
      console.log('⏱ ' + diff.toFixed(0) + ' ms');
    }
    lastClickTime = now;
  }

  if (e.key && e.key.toLowerCase() === 'r') {
    e.preventDefault();
    stopAllAudioImmediate(document);
  
    const postIndex = articleSwiper ? articleSwiper.activeIndex : 0;
    let restoreSlideIndex = 0;
  
    // Ak sme v detaile → zapamätaj aktuálny slide
    if (isDetailView && detailSwiper) {
      restoreSlideIndex = detailSwiper.activeIndex || 0;
    }
  
    // Urči, či ide o Shift + R
    const isShiftReload = e.shiftKey;
  
    // Vyčisti aktuálny detail
    if (detailSwiper && detailSwiper.nextTimeout) clearTimeout(detailSwiper.nextTimeout);
    if (detailSwiper && typeof detailSwiper.destroy === 'function') {
      detailSwiper.destroy(true, true);
      detailSwiper = null;
    }
    contentDiv.innerHTML = '';
  
    fetch(`${WP_DOMAIN}/wp-json/wp/v2/posts?categories=${CATEGORY_ID}&_embed&per_page=100&orderby=date&order=desc`)
      .then(res => res.json())
      .then(posts => {
        const post = posts[postIndex];
        openDetail(post);
  
        // ak držíš SHIFT → po malom čase posuň späť na pôvodný slide
        if (isShiftReload) {
          const targetIdx = Math.min(restoreSlideIndex, detailSwiper.slides.length - 1);
    
          // 👇 Dočasne skry detail
          contentDiv.style.transition = 'opacity 0.4s ease';
          contentDiv.style.opacity = '0';
    
          // 👇 Po malom oneskorení (Swiper init trvá ~200-300 ms)
          setTimeout(() => {
            if (detailSwiper) {
              detailSwiper.slideTo(targetIdx, 0, false); // presuň bez animácie
            }
            // 👇 potom fade-in späť
            requestAnimationFrame(() => {
              contentDiv.style.opacity = '1';
            });
          }, 350);
        }
      });
  }
  

  if (e.key === 'Enter') {
    stopAllAudioImmediate(document);
    if (!isDetailView && articleSwiper) {
      const postIndex = articleSwiper.activeIndex;
      articleContainer.classList.add('hidden');
      setTimeout(function () {
        articleContainer.style.visibility = 'hidden';
        fetch(`${WP_DOMAIN}/wp-json/wp/v2/posts?categories=${CATEGORY_ID}&_embed&per_page=100&orderby=date&order=desc`)


          .then(function (res) { return res.json(); })
          .then(function (posts) {
            const post = posts[postIndex];
            openDetail(post);
          });
      }, 1600);
    } else {
      closeDetail();
    }
  }
});

/* ==============================
   Načítanie článkov
================================= */
/* ==============================
   Overenie tokenu + Načítanie článkov
================================= */

async function isTokenValid(token) {
  try {
    const res = await fetch('https://www.divartwp.sk/di-viewer-tokens/di-viewer-tokens.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token })
    });
    const data = await res.json();
    return !!data.valid;
  } catch (e) {
    console.warn('❌ Token kontrola zlyhala', e);
    return false;
  }
}

(async () => {
  let valid = false;
  let limit = 2;

  const isDivartPublic =
    WP_DOMAIN.includes('divartwp.sk') && Number(CATEGORY_ID) === 24;

  if (isDivartPublic) {
    console.log('🟢 Výnimka: DivArtWP kategória 24 – plný prístup bez tokenu');
    valid = true;
  } else {
    valid = await isTokenValid(LICENSE_TOKEN);
  }

  limit = valid ? 100 : 2;

  console.log(
    valid
      ? `✅ Token platný alebo výnimka – načítavam všetky články (limit ${limit})`
      : `⚠️ Token neplatný – zobrazujem len ${limit} články`
  );

  const url = `${WP_DOMAIN.replace(/\/+$/, '')}/wp-json/wp/v2/posts?categories=${CATEGORY_ID}&_embed&per_page=${limit}&orderby=date&order=desc`;
  console.log('📡 Fetching:', url);

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const posts = await res.json();

    if (!Array.isArray(posts) || posts.length === 0) {
      console.warn('⚠️ Žiadne články v tejto kategórii.');
      const wrapper = articleContainer.querySelector('.swiper-wrapper');
      wrapper.innerHTML = `<div class="no-posts" style="color:#aaa;text-align:center;padding:50px;">⚠️ Žiadne články v kategórii ${CATEGORY_ID} na ${WP_DOMAIN}</div>`;
      return;
    }

    initArticleSwiper(posts);

// 🔹 Automatické otvorenie detailu podľa URL parametra ?p=
const params = new URLSearchParams(window.location.search);
const paramP = params.get('p'); // napr. ?p=music-sheets alebo ?p=123

if (paramP) {
  // Počkame chvíľku, kým sa Swiper inicializuje
  setTimeout(() => {
    let targetPost = null;

    // Ak je číslo → hľadaj podľa ID, inak podľa slugu
    if (/^\d+$/.test(paramP)) {
      targetPost = posts.find(p => String(p.id) === String(paramP));
    } else {
      targetPost = posts.find(p => p.slug === paramP);
    }

    if (targetPost) {
     // console.log('🔹 Automaticky otváram detail pre:', targetPost.slug || targetPost.id);
      openDetail(targetPost);
    } else {
      console.warn('⚠️ Článok nebol nájdený pre ?p=' + paramP);
    }
  }, 1000);
}

  } catch (err) {
    console.error('❌ Chyba pri načítaní článkov:', err);
    const wrapper = articleContainer.querySelector('.swiper-wrapper');
    wrapper.innerHTML = `<div class="no-posts" style="color:#f66;text-align:center;padding:50px;">❌ Chyba pri načítaní z:<br>${WP_DOMAIN}</div>`;
  }
})();




